import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as classnames from 'classnames';
import Swal from 'sweetalert2';
import './PageBackgroundColor.css';
import { loadCoverToBGType } from '../../../../../redux/actions/ui/loadFirstCoverToBackgroundType';
import Item from './Item';
import Lightbox from './../../../../lightbox/Lightbox';
import PageBackgroundImage from './../page-background-image/PageBackgroundImage';
import ParentCategory from './parent-category/ParentCategory';
import {
  getParams,
  getDomain } from './../../../../../redux/helpers/getParams';
import { configExist, getCoverOrientation } from './../../../../../redux/helpers';
import { removeDefaultLayout } from './../../../../../redux/actions/entities/layouts';
import { assignImageToPlaceholder } from '../../../../../redux/actions/entities/datePlaceholders';
import { saveState } from './../../../../../redux/actions/entities/io';
import { dateImageSelected } from '../../../../../redux/actions/ui/dateImageSelected';

class PageBackgroundColor extends Component {
  constructor(args) {
    super(args);
    this.state = {
      backgroundColor: '#FFFFFF',
      backgrounds: null,
      selectedId: '',
      selectedCategory: '',
      lightboxOpened: false,
      thumbnailUrl: '',
      galleryImages: [],
      imageIndex: 0,
      removeBackButton: false,
      selectedBackground: {},
    };
  }

  componentDidMount() {
    const referer = getDomain();
    const backgroundApiURL = configExist('backgroundApiURL', referer);
    const backgroundService = `${backgroundApiURL}/${getParams('lang')}`;
    const { imageList } = this.props;
    if (!this.props.imageList) {
      fetch(backgroundService, {
        cors: 'no-cors',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        credentials: 'include',
      })
        .then(response => response.json())
        .then((backgrounds) => {
          this.setState({
            backgrounds,
          });
        });
    } else {
      this.setState({
        backgrounds: imageList,
      });
    }
  }


  componentDidUpdate(prevProps) {
    const { allIds } = prevProps;
    const {
      allIds: current,
      backgroundType: currentBg,
      dimensions,
    } = this.props;
    const { pageWidth, pageHeight } = dimensions;

    const format = getCoverOrientation(pageWidth, pageHeight);

    if ((allIds.length !== current.length) && (currentBg === 'modern')) {
      this.props.dispatch(removeDefaultLayout(10));
      this.props.dispatch(loadCoverToBGType('loading'));
    }
  }


  setLightbox = () => {
    this.setState({
      lightboxOpened: false,
      thumbnailUrl: '',
      galleryImages: [],
      imageIndex: 0,
    });
  }

  openLightBox = (image, galleryImages, imageIndex) => this.setState({
    lightboxOpened: true,
    thumbnailUrl: image.thumbnailUrl,
    galleryImages,
    imageIndex,
    selectedBackground: image
  })


  toggleList = (e, name) => {
    this.setState(({
      selectedCategory: name,
    }));
  }

  resetCategory = () => {
    this.setState({
      selectedCategory: '',
    });
  }

  assignImageToDatePlaceholders = (subcategoryImages) => {
    const {
      dateAllIds, lang, pageId, pageOrder, pages, dateImageSet,
    } = this.props;

    if (!dateImageSet) {
      this.assignToWholeCalendar(subcategoryImages, dateAllIds);
      this.props.dispatch(dateImageSelected(true));
      return this.props.dispatch(saveState());
    }

    Swal({
      text: lang.date_change_question,
      type: 'question',
      showCancelButton: true,
      confirmButtonText: lang.from_current,
      cancelButtonText: lang.from_first,
    }).then((result) => {
      if (result.value) {
        this.assignToCurrentPage(subcategoryImages, pageId, pageOrder, pages);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.assignToWholeCalendar(subcategoryImages, dateAllIds);
      }
      this.props.dispatch(saveState());
    });
  }

  assignToCurrentPage = (subcategoryImages, pageIndex, pageOrder, pages) => {
    const dateImages = subcategoryImages.filter((element, index) => index >= pageOrder);
    const restPages = pages.slice(pageOrder);
    if (dateImages) {
      dateImages.forEach((element, index) => {
        this.props.dispatch(assignImageToPlaceholder(restPages[index], element));
      });
    }
  }

  assignToWholeCalendar = (subcategoryImages, dateAllIds) => {
    if (subcategoryImages) {
      subcategoryImages.forEach((element, index) => {
        this.props.dispatch(assignImageToPlaceholder(dateAllIds[index], element));
      });
    }
  }

  toggleImages = (e, sublistIndex, subcategoryImages) => {
    if (Object.prototype.hasOwnProperty.call(subcategoryImages[0], 'previewUrl')) {
      return this.setState({
        selectedId: sublistIndex,
      });
    }
    this.props.handleOpen();
    return this.assignImageToDatePlaceholders(subcategoryImages);
  }

  backgroundList = (data, isDate) => {
    const children = (items) => {
      if (items) {
        return items.map((element, index) => (
          <li
            className="bgDropdown "
            onKeyDown={() => {}}
            role="presentation"
            key={`BgItem-${index}`}
          >
            <PageBackgroundImage
              thumbnail={element.thumbnailUrl}
              full={element.fullUrl}
              src={element.previewUrl}
              handleBackgroundOpen={this.props.handleOpen}
              lang={this.props.lang}
              sizes={{
                width: element.sizes !== undefined ? element.sizes.width : 0,
                height: element.sizes !== undefined ? element.sizes.height : 0,
              }}
            />
            <i
              className="fa fa-search lightbox"
              onClick={() => this.openLightBox(element, items, index)}
              onKeyDown={() => {}}
              role="presentation"
            />
          </li>));
      }
      return null;
    };

    const { selectedCategory, selectedId } = this.state;
    if (selectedCategory !== '') {
      const category = Object.values(data.status).find(element => element.name === selectedCategory);
      if (category !== undefined) {
        return (category.items.map((subcategory, index) => {
          const isActive = selectedId === `sublist-${index}`;
          if (!isDate) {
            return (
              <Item
                key={`sublist-${index}`}
                name={subcategory.name}
                isSubcategory="true"
                onClick={e => this.toggleImages(e, `sublist-${index}`, subcategory.images)}
                isActive={isActive}
              >
                <ul className={isActive ? 'active' : ''}>
                  { children(subcategory.images) }
                </ul>
              </Item>
            );
          }
          return (
            <Item
              key={`sublist-${index}`}
              name={subcategory.name}
              isSubcategory="true"
              onClick={e => this.toggleImages(e, `sublist-${index}`, subcategory.images)}
              isActive={isActive}
              image={subcategory.images[1]}
            />
          );
        }));
      }
    }
    if (Object.keys(data.status).length === 0) {
      return null;
    }

    if (!isDate) {
      return (data.status.map((node, index) => (
        <Item
          key={`list-${index}`}
          name={node.name}
          onClick={e => this.toggleList(e, node.name)}
          isSubcategory="false"
        />
      )));
    }
    return (data.status.map((node, index) => (
      <Item
        key={`list-${index}`}
        name={node.name}
        onClick={e => this.toggleList(e, node.name)}
        isSubcategory="false"
        image={node.image}
      />
    )));
  }


  backgroundPicker = () => {
    const {
      removeBackButton, backgrounds, selectedCategory,
    } = this.state;
    const {
      lang, backgroundType, dimensions, coverType, headerSubText, headerText, isDate,
    } = this.props;

    if (backgrounds === null) {
      return false;
    }

    const listBodyClass = isDate ? 'listBody listBody-date' : 'listBody';

    if (backgroundType === '') { return <ParentCategory dimensions={dimensions} lang={lang} coverType={coverType} />; }
    const displayCategoryName = selectedCategory !== '' ? ` - ${selectedCategory}` : '';
    const displayDateInnerText = selectedCategory !== '' ? headerSubText : headerText;
    return (
      <div className={classnames(
        'backgroundPicker',
        `${listBodyClass}`,
        selectedCategory !== '' && 'selectedCategoryHeader'
      )}>
        <div className="header">
          <h2
            className={classnames(
              selectedCategory !== '' && 'hide', 
            )}
          >
            {displayDateInnerText || lang.background_color} { displayCategoryName }
          </h2>
          { !removeBackButton && selectedCategory !== '' ?
            <div
              className="back"
              onClick={() => this.resetCategory()}
              onKeyDown={() => {}}
              role="presentation"
            >
              <i className="fa fa-arrow-left" aria-hidden="true" />
              <span>{lang.back}</span>
            </div>
           : ''}

        </div>
        <div className={listBodyClass}>
          <ol>
            { this.backgroundList(backgrounds, isDate) }
          </ol>
        </div>
      </div>
    );
  }


  render() {
    const {
      lightboxOpened,
      thumbnailUrl,
      galleryImages,
      imageIndex,
      selectedBackground,
    } = this.state;

    const {
      lang,
      handleOpen
    } = this.props;

    return (
      <div>
        { this.backgroundPicker() }
        {lightboxOpened && <Lightbox imageIndex={imageIndex} setLightBox={this.setLightbox} galleryImages={galleryImages} url={thumbnailUrl} lang={lang} handlerDropdown={handleOpen} selectedBackground={selectedBackground} />}
      </div>
    );
  }
}

PageBackgroundColor.defaultProps = {
  lang: {},
  allIds: [],
  pageId: 10,
  pageOrder: 1,
  backgroundType: '',
  dimensions: {},
  dispatch: () => {},
  coverType: {},
  pages: [],
  headerText: '',
  dateAllIds: [],
  handleOpen: () => {},
  dateImageSet: false,
  headerSubText: '',
  isDate: false,
};

PageBackgroundColor.propTypes = {
  lang: PropTypes.object,
  pageId: PropTypes.number,
  pageOrder: PropTypes.number,
  backgroundType: PropTypes.string,
  dimensions: PropTypes.object,
  dispatch: PropTypes.func,
  coverType: PropTypes.object,
  allIds: PropTypes.array,
  pages: PropTypes.array,
  headerText: PropTypes.string,
  dateAllIds: PropTypes.array,
  handleOpen: PropTypes.func,
  dateImageSet: PropTypes.bool,
  headerSubText: PropTypes.string,
  isDate: PropTypes.bool,
};

export default connect(state => ({
  backgroundType: state.editorUI.bookProperties.backgroundType,
  context: state.bookProperties.context,
  dimensions: state.bookProperties.dimensions,
  coverType: state.bookProperties.cover,
  allIds: state.entities.layouts.allIds,
  dateAllIds: state.entities.datePlaceholders.allIds,
  backgroundSelected: state.editorUI.backgroundImageSelected,
  dateImageSet: state.editorUI.dateImageSelected,
}))(PageBackgroundColor);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/colors/page-background-color/PageBackgroundColor.jsx